"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _ansiToReact = require("ansi-to-react");

var _ansiToReact2 = _interopRequireDefault(_ansiToReact);

var _transforms = require("@nteract/transforms");

var _richestMime = require("./richest-mime");

var _richestMime2 = _interopRequireDefault(_richestMime);

var _immutable = require("immutable");

var Immutable = _interopRequireWildcard(_immutable);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(function () {
  var enterModule = require('react-hot-loader').enterModule;

  enterModule && enterModule(module);
})();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var classPrefix = "nteract-display-area-";

var Output = function (_React$Component) {
  _inherits(Output, _React$Component);

  function Output() {
    _classCallCheck(this, Output);

    return _possibleConstructorReturn(this, (Output.__proto__ || Object.getPrototypeOf(Output)).apply(this, arguments));
  }

  _createClass(Output, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps) {
      return (
        // NOTE: this only does a shallow comparison that mostly only works
        //       well for Immutable Outputs
        nextProps.output !== this.props.output || nextProps.displayOrder !== this.props.displayOrder || nextProps.transforms !== this.props.transforms || nextProps.theme !== this.props.theme || nextProps.models !== this.props.models
      );
    }
  }, {
    key: "render",
    value: function render() {
      var output = this.props.output;
      var models = this.props.models;

      // TODO: Incorporate the new output record types into both commutable and the react components that use them
      if (Immutable.isImmutable(output)) {
        output = output.toJS();
      }
      if (Immutable.isImmutable(models)) {
        models = models.toJS();
      }

      var outputType = output.output_type;

      switch (outputType) {
        case "execute_result":
        // We can defer to display data here, the cell number will be handled
        // separately. For reference, it is output.execution_count
        // The execution_count belongs in the component above if
        // this is a code cell

        // falls through
        case "display_data":
          {
            var bundle = output.data;
            var metadata = output.metadata;
            return _react2.default.createElement(_richestMime2.default, {
              bundle: bundle,
              metadata: metadata,
              displayOrder: this.props.displayOrder,
              transforms: this.props.transforms,
              theme: this.props.theme,
              models: models
            });
          }
        case "stream":
          {
            var text = output.text;
            var name = output.name;
            switch (name) {
              case "stdout":
              case "stderr":
                return _react2.default.createElement(
                  _ansiToReact2.default,
                  { className: classPrefix + name },
                  text
                );
              default:
                return null;
            }
          }
        case "error":
          {
            var traceback = output.traceback;
            if (!traceback) {
              return _react2.default.createElement(
                _ansiToReact2.default,
                { className: classPrefix + "traceback" },
                output.ename + ": " + output.evalue
              );
            }
            return _react2.default.createElement(
              _ansiToReact2.default,
              { className: classPrefix + "traceback" },
              traceback.join("\n")
            );
          }
        default:
          return null;
      }
    }
  }, {
    key: "__reactstandin__regenerateByEval",
    // @ts-ignore
    value: function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }]);

  return Output;
}(_react2.default.Component);

Output.defaultProps = {
  models: {},
  theme: "light",
  transforms: _transforms.transforms,
  displayOrder: _transforms.displayOrder
};
var _default = Output;
exports.default = _default;
;

(function () {
  var reactHotLoader = require('react-hot-loader').default;

  var leaveModule = require('react-hot-loader').leaveModule;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(classPrefix, "classPrefix", "src/output.js");
  reactHotLoader.register(Output, "Output", "src/output.js");
  reactHotLoader.register(_default, "default", "src/output.js");
  leaveModule(module);
})();

;


//////////////////
// WEBPACK FOOTER
// ./~/@nteract/display-area/lib/output.js
// module id = 119
// module chunks = 186292428941015